import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Switch } from 'antd'

import { AppUrls } from 'common/AppUrls'
import { onCallPreferencesChange, changeAutoReject, changeAutoPickup } from 'store/actions/settings'
import { PageHeaderWithButtons } from 'components/shared'
import { useTranslation } from 'react-i18next'
import './CallPreferences.scss'

function CallPreferenceItem({ id, name, isChecked }) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    function onChangePreferenceHandler(checked) {
        dispatch(onCallPreferencesChange({ id, checked }))
    }

    return (
        <div key={id} className="call-preferences__item d-flex justify-content-between">
            <span>{t(`keyboard_shortcuts.${name}`)}</span>
            <Switch checked={isChecked} className="app__switcher" size="small" onChange={onChangePreferenceHandler} />
        </div>
    )
}

export const CallPreferences = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const { callPreferences, autoReject, autoPickup } = useSelector((state) => state.settings)

    const onChangeAutoReject = (checked) => {
        dispatch(changeAutoReject(checked))
    }

    const onChangeAutoPickup = (checked) => {
        dispatch(changeAutoPickup(checked))
    }

    return (
        <>
            <PageHeaderWithButtons backUrl={AppUrls.settings} pageName={t('call_preferences')} />
            <div className="general">
                <span className="call-preferences__title">{t('general')}</span>
                <div
                    className="call-preferences__item d-flex justify-content-between"
                    data-toggle="tooltip"
                    tooltip={t('auto_reject_tooltip')}
                >
                    <span>{t('auto_reject')}</span>
                    <Switch className="app__switcher" size="small" checked={autoReject} onChange={onChangeAutoReject} />
                </div>
                <div
                    className="call-preferences__item d-flex justify-content-between"
                    data-toggle="tooltip"
                    tooltip={t('auto_pickup_tooltip')}
                >
                    <span>{t('auto_pickup')}</span>
                    <Switch className="app__switcher" size="small" checked={autoPickup} onChange={onChangeAutoPickup} />
                </div>
            </div>
            <div className="shorcuts">
                <span className="call-preferences__title">{t('keyboard_shortcuts.title')}</span>
                {callPreferences.map(({ id, name, isChecked }) => (
                    <CallPreferenceItem key={id} {...{ id, name, isChecked }} />
                ))}
            </div>
        </>
    )
}
